const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLibreLogos(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient48143",
    gradientUnits: "userSpaceOnUse",
    x1: 531.87238,
    y1: 343.93735,
    x2: 541.99878,
    y2: 344.3089
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#1a1a1a",
      stopOpacity: 0
    },
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#000000",
      stopOpacity: 1
    },
    offset: 0.47895929
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#1a1a1a",
      stopOpacity: 0
    },
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient38778",
    gradientUnits: "userSpaceOnUse",
    x1: 2064.6768,
    y1: 1269.2305,
    x2: 2034.417,
    y2: 1430.791
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ffcc00",
      stopOpacity: 1
    },
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ff0000",
      stopOpacity: 1
    },
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient48145",
    gradientUnits: "userSpaceOnUse",
    x1: 527.63635,
    y1: 385.22964,
    x2: 537.04999,
    y2: 342.48355
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ffcc00",
      stopOpacity: 1
    },
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ff0000",
      stopOpacity: 1
    },
    offset: 1
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-88.508842,-105.1113)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#linearGradient48149)",
      fillOpacity: 1,
      strokeWidth: 0.853673,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "m 91.344655,106.64764 a 0.42687899,0.42687899 0 0 0 -0.412311,0.31643 l -2.409054,8.99794 a 0.42687899,0.42687899 0 0 0 0.412312,0.537 h 6.798197 a 0.42687899,0.42687899 0 0 0 0.412312,-0.31644 l 0.804367,-2.99961 a 0.42687899,0.42687899 0 0 0 -0.412311,-0.53745 h -2.846124 l 1.464249,-5.46043 a 0.42687899,0.42687899 0 0 0 -0.412314,-0.53744 z m 0.32769,0.85388 h 2.515283 l -1.464246,5.46043 a 0.42687899,0.42687899 0 0 0 0.412311,0.53745 h 2.846123 l -0.575707,2.14618 h -5.914606 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.336086,
      fill: "url(#linearGradient48147)",
      fillOpacity: 1,
      stroke: "none"
    },
    d: "m 91.916248,107.50152 0.228797,-0.85388 h 2.027474 l -0.228797,0.85388 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#linearGradient48145)",
      fillOpacity: 1,
      strokeWidth: 0.853673,
      stroke: "none"
    },
    d: "m 93.471604,105.1113 c -0.193211,1e-5 -0.362315,0.1298 -0.412305,0.31643 l -2.409049,8.99797 c -0.07235,0.27098 0.13183,0.53691 0.412305,0.537 h 4.527157 l 0.22866,-0.85344 h -4.199881 l 2.180863,-8.14405 h 2.515282 l -1.464267,5.4605 c -0.07264,0.2711 0.131638,0.53733 0.412307,0.53735 h 2.846128 l -0.575703,2.1462 h -0.831209 l -0.228661,0.85344 h 1.387496 c 0.19321,-2e-5 0.362317,-0.1298 0.412307,-0.31643 l 0.804365,-2.99965 c 0.07264,-0.2711 -0.131636,-0.53733 -0.412305,-0.53735 h -2.84613 l 1.464272,-5.4605 c 0.07273,-0.27115 -0.131573,-0.53747 -0.412304,-0.53747 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.336086,
      fill: "url(#linearGradient48143)",
      fillOpacity: 1,
      stroke: "none"
    },
    d: "m 95.261839,114.10879 -0.2289,0.85391 h 0.556411 l 0.229022,-0.85391 z m 1.440334,0 -0.2289,0.85391 h 0.587138 l 0.2289,-0.85391 z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLibreLogos);
export default __webpack_public_path__ + "static/media/libre-logos.e7a23e18ce0578e8ac5a8f267c822eb1.svg";
export { ForwardRef as ReactComponent };